import type {
  IListConf,
} from '../../project/types.d';
import { MovieListClass } from './movie-list';

const { Data, RenderMovie, Util } = window.Project;

class FavoriteListClass extends MovieListClass {

    async update(conf: Partial<IListConf>): Promise<void> {
      this.conf = { ...this.conf, ...conf };
    }

    async render(): Promise<void> {
      const master = await Data.fetchMaster();
      this.limit = this.calcLimit();
      const list = Util.times(this.limit, (i) => RenderMovie.getFavoriteListItem(this.movies[i], master));
      this.el.innerHTML = list.join('');
      this.el.classList.toggle('g-mediaList-empty', list.length === 0);

      this.watchScroll(false);
      this.watchScroll(true);
    }

    async refresh(conf: Partial<IListConf>): Promise<void> {
        await this.update(conf);
        await this.render();
    }
}

export const FavoriteList = new FavoriteListClass();
